import config from "config";
import API from "./http";

const reports = {
  async getBalance() {
    try {
      const res = await API.get(`${config.CORP_API_URL}/reports/balance`);
      return res.data;
    } catch (err) {
      console.error("Error getting balance report", err);
      throw err;
    }
  },
  async getStatement(
    { startDate, endDate, fleetUserId, registrationPlate, department },
    limit = 50,
    page = 0
  ) {
    try {
      const params = {
        startDate,
        endDate,
        limit,
        page
      };

      if (registrationPlate) {
        params.registrationPlate = registrationPlate;
      }

      if (fleetUserId) {
        params.fleetUserId = fleetUserId;
      }

      if (department) {
        params.fleetUserId = fleetUserId;
      }

      const res = await API.get(`${config.CORP_API_URL}/reports/statement`, {
        params
      });

      return res.data;
    } catch (err) {
      console.error("Error getting statement report", err);
      throw err;
    }
  },
  async getRecentStatements(    
    limit = 15
  ) {
    try {
      const params = {
        limit,
      };

      const res = await API.get(`${config.CORP_API_URL}/reports/statement/recent`, {
        params
      });

      return res.data;
    } catch (err) {
      console.error("Error getting last statements report", err);
      throw err;
    }
  },
  async getDepartments() {
    try {
      const res = await API.get(
        `${config.CORP_API_URL}/fleet-users/departments`
      );

      return res.data;
    } catch (err) {
      console.error("Error getting departments filters", err);
      throw err;
    }
  },
  async getFleetVehicles() {
    try {
      const res = await API.get(
        `${config.CORP_API_URL}/fleet-vehicles`
      );

      return res.data;
    } catch (err) {
      console.error("Error getting departments filters", err);
      throw err;
    }
  }
};

export default reports;
